var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NewsTicker',{attrs:{"tag":_vm.tag,"posts":_vm.posts,"title":_vm.title,"button-label":_vm.buttonLabel}})}
var staticRenderFns = []

export { render, staticRenderFns }